import { reducer as baseReducer } from './actions.js';
import { reducer as filterReducer } from './filterActions.js';
import { reducer as formReducer } from './formActions.js';
import { reducer as lowfareReducer } from './lowfareActions.js';
import { reducer as savedSearchReducer } from './savedSearchActions.js';

import defaultState from './defaultState.js';

export const rootReducer = (state, action) => {
    switch (action.type) {
        case '@@INIT':
            return defaultState;
        default:
            return state;
    }
};

export default (state, action) =>
    Object.assign({}, rootReducer(state, action), baseReducer(state, action), {
        filterState: filterReducer(state.filterState, action),
        searchForm: formReducer(state.searchForm, action),
        lowfare: lowfareReducer(state.lowfare, action),
        savedSearch: savedSearchReducer(state.savedSearch, action),
    });
